const Score: React.FC<{ value: number | null }> = ({ value }) => {
  if (value === null || value === undefined) return <>N/A</>

  const num = value

  if (isNaN(num)) return <>N/A</>

  return <>{Number.isInteger(num) ? num : num.toFixed(2)}</>
}

export { Score }
